import React from 'react'
import styles from './Modal.module.scss'

interface ModalProps {
  visible: boolean
  onClose?: () => void
  children: React.ReactNode
  type?: string | null
}

const Modal: React.FC<ModalProps> = ({ visible, onClose, children, type }) => {
  if (!visible) {
    return null
  }

  return (
    <>
      <div
        className={`${styles.overlay} ${
          type === 'centered-parent' && styles.centeredParent
        }`}
        onClick={() => onClose && onClose()}
      ></div>
      <div className={styles.popup}>
        {onClose && (
          <p className={styles.closeButton} onClick={onClose}>
            X
          </p>
        )}
        {children}
      </div>
    </>
  )
}

export default Modal
